import { SECOND_MS } from '../../time';
import { isEmptyObject } from '../../utils/records';
export var areAllGoalsFulfilled = function (goals) {
    return Object.values(goals).every(function (goal) { return !goal.isRequired || goal.isFulfilled; });
};
export var getCardsRatingSum = function (_a) {
    var collection = _a.collection, progress = _a.progress;
    return !progress
        ? 0
        : collection.slots
            .map(function (slot, i) {
            var _a, _b;
            var insertedCard = progress.slots[i];
            if (isEmptyObject(slot) ||
                isEmptyObject(insertedCard) ||
                !(insertedCard === null || insertedCard === void 0 ? void 0 : insertedCard.card)) {
                return 0;
            }
            var group = collection.cardGroups.find(function (_a) {
                var id = _a.id;
                return slot.group === id;
            });
            if (!group) {
                return 0;
            }
            return ((_b = (_a = group.cards.find(function (_a) {
                var cardTemplate = _a.cardTemplate;
                return cardTemplate === insertedCard.cardTemplate;
            })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 0);
        })
            .reduce(function (sum, value) { return sum + value; }, 0);
};
export var anyCardGroupIncludesCard = function (cardGroups, cardTemplateId) {
    return cardGroups.some(function (group) {
        return group.cards.some(function (groupCard) { return groupCard.cardTemplate === cardTemplateId; });
    });
};
export var collectionProgressFetchErrors = {
    notFound: 'collections_pu_error_notfound',
    notAvailableForRegion: 'collections_pu_error_regional',
};
export var getRankingItemWithoutUserData = function (item) { return ({
    fetchingInProgressSince: item.fetchingInProgressSince,
    lastSuccessfulFetch: item.lastSuccessfulFetch,
    lastFailedFetch: item.lastFailedFetch,
    fetchPromise: item.fetchPromise,
    didInvalidate: item.didInvalidate,
    top: item.top,
    nextRefreshEstimate: item.nextRefreshEstimate,
    updatedAt: item.updatedAt,
}); };
export var compareRankingEntries = function (entry1, entry2) {
    return entry1.username === entry2.username &&
        entry1.no === entry2.no &&
        entry1.value === entry2.value;
};
var RANKING_REFRESH_DELAY = 30 * SECOND_MS;
export var getMillisUntilNextRefresh = function (nextRefreshEstimate) {
    return nextRefreshEstimate - Date.now() + RANKING_REFRESH_DELAY;
};
export var getMillisUntilNextRankingRefresh = function (ranking) {
    if (ranking.nextRefreshEstimate < 0) {
        return Infinity;
    }
    return getMillisUntilNextRefresh(ranking.nextRefreshEstimate);
};
export var ownedCollectionsSliceName = 'cardsCollectionsOwned';
export var collectionProgressName = 'cardsCollectionsProgress';
export var collectionsListSliceName = 'cardsCollectionsList';
export var collectionRankingName = 'cardsCollectionRanking';
export var REMOVE_CARDS_FROM_COLLECTIONS = 'REMOVE_COLLECTION_CARDS';
export var HIDE_COLLECTION = 'HIDE_COLLECTION_CAMPAIGN';
export var FETCH_COLLECTION_PROGRESS_FAILED_REGIONAL = 'FETCH_COLLECTION_PROGRESS_FAILED_REGIONAL';
